export const perkQuirkLikeLabel = (type?: string): string => {
  if (type === "perk") {
    return "That's for me";
  }
  return "Not a problem";
};

export const perkQuirkDislikeLabel = (type?: string): string => {
  if (type === "perk") {
    return "Not Important";
  }
  return "Yikes";
};
